<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <div class="banner-header">
    <div class="banner-header__content">
      <h2>{{ 'MODALS.existing3a.title' | translate }}</h2>
      <h3>{{ 'MODALS.existing3a.subtitle' | translate }}</h3>
    </div>
    <div class="banner-header__image">
      <img [src]="'/assets/images/3a-modal-header.png'" />
    </div>
  </div>
  <div class="banner-content">
    <ul>
      <li
        (click)="openDetails('account')"
        [innerHTML]="'MODALS.existing3a.list.1' | translate:{ amountSmall: amountSmall | thousand:'CHF', amountLarge: amountLarge | thousand:'CHF' }"
      ></li>
      <li (click)="openDetails('savings')" [innerHTML]="'MODALS.existing3a.list.2' | translate"></li>
      <li (click)="openDetails('transfer')" [innerHTML]="'MODALS.existing3a.list.3' | translate"></li>
    </ul>
    <ion-button mode="ios" expand="block" (click)="openDetails('account')">{{ 'MODALS.existing3a.cta' | translate }}</ion-button>
  </div>
</ion-content>
